const FieldLabel = ({ label, for: forProp }) => (
  <label className="block mb-1 text-sm text-gray-700" htmlFor={forProp}>
    {label}
  </label>
);

export default FieldLabel;
